var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProveedor = function SvgProveedor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "proveedor_svg__Capa_2",
    viewBox: "0 0 43.59 43.59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "proveedor_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68 26.2h20.49v17.39H11.68z",
    fill: "#22aa9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.23 19.17-14.1-14.2C25.95 1.77 24.2 0 21.79 0s-4.16 1.76-7.34 4.97L.36 19.17a1.231 1.231 0 0 0 1.74 1.74l1.8-1.81v19.98c0 2.49 2.03 4.52 4.52 4.52h6.39l.06-9.1c.88-3.79 4.11-5.49 6.91-5.49s6.03 1.7 6.91 5.49l.03.27.04 8.82h6.39c2.49 0 4.52-2.03 4.52-4.52V19.09l1.8 1.81c.48.48 1.26.49 1.74 0 .48-.48.49-1.26 0-1.74Z",
    fill: "#55ddd2"
  }))));
};
export default SvgProveedor;